import Candidates from './Candidates.json';

export default {
  Candidates,
};
